import { Route, Routes } from 'react-router-dom';
import './App.css';
import "./i18n.js";

import Login from './page/auth/login/login';
import LayoutMain from './component/layout/layoutMain';
import LayoutAuth from './component/layout/layoutAuth';
import ForgotPassword from './page/auth/forgotPassword/forgotPassword';
import OTPConfim from './page/auth/otpConfim/otpConfim';
import ConfimPassword from './page/auth/confimPassword/confimPassword';
import SharedDocuments from './page/documents/sharedDocuments/sharedDocuments';
import MyDocuments from './page/documents/myDocuments/myDocuments';
import CreateMyDocuments from './page/documents/myDocuments/createMyDocuments';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Dashboard from './page/dashboard/dashboard';
import Report from './page/report/report';
import StatisticsUsage from './page/statistics/statisticsUsage/statisticsUsage';
import StatisticsDownload from './page/statistics/statisticsDownload/statisticsDownload';
import Agencies from './page/settings/agencies/agencies';
import Users from './page/settings/users/users';
import Permissions from './page/settings/permissions/permissions';
import Customize from './page/settings/customize/customize';
import SearchResults from './page/searchResults/searchResults';
import EditPermissions from './page/settings/permissions/editPermissions';
import { getToken } from './utils/app.utils';
import envInstants from './configs/env';
import { setDefaultURL } from './api/api';
import { CircularProgress } from '@mui/material';
import { profileAsync } from './app/slice/profile.slice';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import ReportSummaryByFileExtention from './page/report/reportSummaryByFileExtention';
import ReportSummaryByDepartment from './page/report/reportSummaryByDepartment';
import ReportSummaryByDocumentType from './page/report/reportSummaryByDocumentType';
import ReportSummaryByFiscalyear from './page/report/reportSummaryByFiscalyear';
import Notification from './page/notification/notification';
import ReportAllFiles from './page/report/reportAllFiles';
import ListPosition from './page/settings/position/list/list';

function App() {
  const Dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const location = useLocation();
  const [isInitEnvError, setInitEnvError] = useState<boolean>(false);
  const [isInitEnv, setInitEnv] = useState<boolean>(false);
  const token = getToken();
  useEffect(() => {

    if (!token) {
      navigate("/login")
    } else {
      if (location.pathname === '/') {
        navigate('/dashboard')
      }
      // setPermission(permit)     
      // if (location.pathname === '/') {
      //   navigate(baseUrl)
      // }
    }
  }, [token]);
 
  useEffect(() => {
    

    const loadEnv = async () => {
      try {
        await envInstants.init();
        setDefaultURL(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
      } finally {
        Dispatch(profileAsync());
        setInitEnv(true);
      }
    };

    loadEnv();
  }, [])


  if (!isInitEnv) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: "100vh" }}><CircularProgress /></div>;
  if (isInitEnvError) return <div>"Cannot load env !!!"</div>;


  return (
    <>
      <Routes>
        {
          !token ? [
            { path: '/login', name: 'Login', component: <Login /> },
            { path: '/forgot-password', name: 'Forgot-Password', component: <ForgotPassword /> },
            { path: '/OTP-confim', name: 'OTP-Confim', component: <OTPConfim /> },
            { path: '/confim-password', name: 'Confim-Password', component: <ConfimPassword /> },
          ].map((x: any, i: number) => {
            return <Route key={i} path={x.path} element={
              <LayoutAuth>
                {x.component}
              </LayoutAuth>} />
          }) : [{ path: '/dashboard', name: 'Dashboard', component: <Dashboard /> },
          { path: '/shared-documents', name: 'shared-documents', component: <SharedDocuments /> },
          { path: '/my-documents', name: 'my-documents', component: <MyDocuments /> },
          { path: '/create-my-documents', name: 'create-my-documents', component: <CreateMyDocuments /> },
          { path: '/report', name: 'report', component: <Report /> },
          { path: '/report-summary-by-file-extention', name: 'report', component: <ReportSummaryByFileExtention /> },
          { path: '/report-summary-by-document-type', name: 'report', component: <ReportSummaryByDocumentType /> },
          { path: '/report-summary-by-department', name: 'report', component: <ReportSummaryByDepartment /> },
          { path: '/report-summary-by-fiscalyear', name: 'report', component: <ReportSummaryByFiscalyear /> },
          { path: '/report-all-files', name: 'report', component: <ReportAllFiles /> },
          { path: '/statistics-usage', name: 'statistics-usage', component: <StatisticsUsage /> },
          { path: '/statistics-download', name: 'statistics-download', component: <StatisticsDownload /> },
          { path: '/settings-agencies', name: 'settings-agencies', component: <Agencies /> },
          { path: '/settings-position', name: 'settings-position', component: <ListPosition /> },
          { path: '/settings-users', name: 'settings-users', component: <Users /> },
          { path: '/settings-permissions', name: 'settings-permissions', component: <Permissions /> },
          { path: '/settings-permissions-add', name: 'settings-permissions-add', component: <EditPermissions /> },
          { path: '/settings-permissions-edit/:id', name: 'settings-permissions-edit', component: <EditPermissions /> },
          { path: '/settings-customize', name: 'settings-customize', component: <Customize /> },
          { path: '/search-results', name: 'search-results', component: <SearchResults /> },
          { path: '/notifications', name: 'notifications', component: <Notification /> },
          ].map((x: any, i: number) => {
            return <Route key={i} path={x.path} element={
              <LayoutMain>
                {x.component}
              </LayoutMain>
            } />
          })}

      </Routes>
    </>
  );
}

export default App;
